import React from "react";
import {
  Box,
  Typography,
  Button,
  Container,
  Card,
  CardContent,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BarChartIcon from "@mui/icons-material/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { useNavigation } from "../lib/NavigationContext";

export default function Reports() {
  const { navigateTo } = useNavigation();
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 4,
        }}
      >
        <Box>
          <Typography variant="h5" fontWeight={700}>
            Report e Statistiche
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Analizza le performance e i dati dei preventivi
          </Typography>
        </Box>
        <Button
          onClick={() => navigateTo("Quote")}
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          size="small"
        >
          Torna ai Preventivi
        </Button>
      </Box>

      <Card elevation={3}>
        <CardContent sx={{ p: 8, textAlign: "center" }}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              bgcolor: "action.hover",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 3,
            }}
          >
            <BarChartIcon sx={{ fontSize: 40, color: "text.disabled" }} />
          </Box>
          <Typography variant="h6" color="text.secondary" gutterBottom>
            Report non disponibili
          </Typography>
          <Typography
            variant="body2"
            color="text.disabled"
            sx={{ maxWidth: 400, mx: "auto" }}
          >
            Le statistiche e i report appariranno qui quando avrai generato
            dei preventivi.
          </Typography>
          <Button
            onClick={() => navigateTo("Quote")}
            variant="contained"
            startIcon={<TrendingUpIcon />}
            sx={{ mt: 3 }}
          >
            Inizia a Preventivare
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
}
